module.exports = __webpack_public_path__ + "static/media/5.b885f258.jpg";